import React, { useState } from "react";
import { DeleteButton } from "../../styles";
import {
  Paper,
  Alert,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import API from "../../../../axios/instances/API";
import { FEEDBACK_MESSAGES, JOB_TYPES } from "../../../../storage/constants";
import styled from "styled-components";
import useGlobalStore from "src/store/useGlobalStore";

const DeleteWrapperTwo = styled(Paper)`
  padding: 20px;
  width: 400px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  border: 2px solid
    ${(props) =>
      props.$modalMood === "positive" ? "mediumseagreen" : "tomato"};
  border-radius: 8px;
`;

const handleErrorMsg = (error) => {
  if (error?.response?.data?.error?.title) {
    return {
      title: error?.response?.data?.error?.title || "ERROR",
      details:
        error?.response?.data?.error?.details ||
        FEEDBACK_MESSAGES.GENERIC_ERROR,
    };
  }
  return {
    title: "Error",
    details: FEEDBACK_MESSAGES.GENERIC_ERROR,
  };
};

const PendingModal = ({
  pendingData,
  setPendingData,
  mutate,
  setSnackbarText,
  teamMutate,
}) => {
  const refetchConfigBackground = useGlobalStore(
    (state) => state.refetchConfigBackground,
  );
  const [isDeleting, setIsDeleting] = useState(false);
  const [errorAlert, setErrorAlert] = useState(null);

  const handleDelete = async () => {
    setErrorAlert(false);
    setIsDeleting(true);
    try {
      await API.delete("dashboard/teams/pending/", {
        data: {
          id: pendingData.id,
        },
      });
      await refetchConfigBackground();
      mutate();
      setIsDeleting(false);
      setSnackbarText(`Declined pending user ${pendingData.name} warning`);
      setPendingData(null);
    } catch (error) {
      const errorObj = handleErrorMsg(error);
      setErrorAlert(errorObj);
      setIsDeleting(false);
    }
  };

  const handleApprove = async () => {
    setErrorAlert(false);
    setIsDeleting(true);
    try {
      await API.put("dashboard/teams/pending/", {
        id: pendingData.id,
      });
      await refetchConfigBackground();
      await mutate();
      setIsDeleting(false);
      teamMutate();
      setSnackbarText(`Approved pending user ${pendingData.name} success`);
      setPendingData(null);
    } catch (error) {
      const errorObj = handleErrorMsg(error);
      setErrorAlert(errorObj);
      setIsDeleting(false);
    }
  };

  if (pendingData.action === JOB_TYPES.APP_USER) {
    return (
      <DeleteWrapperTwo $modalMood="positive">
        <Typography variant="h5" component="h5">
          Approve Team Member Request?
        </Typography>
        <Typography sx={{ mb: 3 }} style={{ fontWeight: "400", fontSize: 14 }}>
          {pendingData.name}
        </Typography>
        <Button
          fullWidth
          variant="contained"
          style={{
            borderRadius: 6,
            backgroundColor: isDeleting ? "lightgray" : "mediumseagreen",
          }}
          onClick={handleApprove}
          startIcon={
            isDeleting && <CircularProgress size={16} sx={{ color: "white" }} />
          }
        >
          {" "}
          {isDeleting ? "Approving" : "Approve"}
        </Button>
        {errorAlert && (
          <Alert
            style={{ textAlign: "left" }}
            sx={{ mt: 4 }}
            severity="error"
            onClose={() => setErrorAlert(null)}
          >
            <p style={{ fontWeight: "600" }}>{errorAlert?.title}</p>
            <p>{errorAlert.details}</p>
          </Alert>
        )}
      </DeleteWrapperTwo>
    );
  }

  return (
    <DeleteWrapperTwo $modalMood="negative">
      <Typography variant="h5" component="h5">
        Decline Team Member Request?
      </Typography>
      <Typography
        sx={{ mb: 3, mt: 1 }}
        style={{ fontWeight: "400", fontSize: 14 }}
      >
        {pendingData.name}
      </Typography>
      <DeleteButton
        fullWidth
        disabled={isDeleting}
        style={{ borderRadius: 6 }}
        onClick={handleDelete}
        startIcon={
          isDeleting && <CircularProgress size={16} sx={{ color: "white" }} />
        }
      >
        {" "}
        {isDeleting ? "Declining" : "Decline"}
      </DeleteButton>
      {errorAlert && (
        <Alert
          style={{ textAlign: "left" }}
          sx={{ mt: 4 }}
          severity="error"
          onClose={() => setErrorAlert(null)}
        >
          <p style={{ fontWeight: "600" }}>{errorAlert?.title}</p>
          <p>{errorAlert.details}</p>
        </Alert>
      )}
    </DeleteWrapperTwo>
  );
};

export default PendingModal;
